import LegalPage from '@/pages/legal/LegalPage';

const sections = [
  { titleKey: 'legal.security_section1_title', textKey: 'legal.security_section1_text' },
  { titleKey: 'legal.security_section2_title', textKey: 'legal.security_section2_text' },
  { titleKey: 'legal.security_section3_title', textKey: 'legal.security_section3_text' },
  { titleKey: 'legal.security_section4_title', textKey: 'legal.security_section4_text' },
  { titleKey: 'legal.security_section5_title', textKey: 'legal.security_section5_text' },
  { titleKey: 'legal.security_section6_title', textKey: 'legal.security_section6_text' },
];

export default function Security() {
  return (
    <LegalPage
      titleKey="legal.security_title"
      lastUpdatedKey="legal.security_last_updated"
      introKey="legal.security_intro"
      sections={sections}
      contactKey="legal.security_contact"
      seo={{
        title: 'Security - Texio | Enterprise-Grade Textile ERP Security',
        description: 'Texio Security — enterprise-grade infrastructure, AES-256 encryption, RBAC access control, SOC 2 compliance, and incident response for your textile factory data.',
        keywords: 'Texio security, ERP security, textile data protection, AES-256 encryption, SOC 2 compliance, factory data security',
        canonicalUrl: '/security',
      }}
    />
  );
}